import { useEffect, useState } from "react"
import rpc from "@/src/rpc"
import LoadingSpinner from "./LoadingSpinner"
import LoadingOverlay from "./LoadingOverlay"
import { SCOPE_DESCRIPTIONS } from "@/src/oauthScopes"
import SimpleDate from "@/lib/SimpleDate"


export default function ApiSettings () {
  const [mounted, setMounted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [apps, setApps] = useState([])

  async function load () {
    const result = await rpc('oauthApps.authorized')
    setApps(result || [])
    setMounted(true)
  }

  useEffect(() => { load() }, [])


  async function revoke (app) {
    if (!confirm(`Revoke access for "${app.name}"? It will no longer be able to access this organization.`)) return
    setLoading(true)
    try {
      await rpc('oauthApps.revoke', { applicationId: app.applicationId }, { throwErrors: true })
      await load()
    } catch (err) {
      alert(err.message || 'Failed to revoke access')
    }
    setLoading(false)
  }


  if (!mounted) return <LoadingSpinner size="medium"/>

  return (
    <section className="section">
      <div className="content px-4 py-2">
        <LoadingOverlay visible={loading}/>

        <h2 className="title is-5 mb-0">API Access</h2>
        <p className="gray text-sm my-3">
          Apps you&apos;ve authorized to access this organization through the Social Jazz API.
        </p>

        { apps.length === 0 ?
          <p className="gray my-4">
            No apps have been authorized yet. When you connect a third-party app to Social Jazz
            and approve its request, it will appear here.
          </p>
        :
          <div className="flex-col gap-2 my-3">
            { apps.map(app => (
              <div key={app.applicationId} className="border rounded p-3 flex-row spread flex-align-start gap-3">
                <div className="flex-col gap-1">
                  <div className="bold">{app.name}</div>
                  <div className="text-sm gray">
                    Authorized {new SimpleDate(app.authorizedAt).toString()}
                  </div>
                  { app.scopes &&
                    <ul className="text-sm gray" style={{margin: '4px 0 0', paddingLeft: 18}}>
                      { app.scopes.split(' ').filter(Boolean).map(s => (
                        <li key={s}>{SCOPE_DESCRIPTIONS[s] || s}</li>
                      )) }
                    </ul>
                  }
                </div>
                <button className="button is-small is-inverted red" onClick={() => revoke(app)}>
                  Revoke
                </button>
              </div>
            )) }
          </div>
        }
      </div>
    </section>
  )
}
